import { useQuery } from "@tanstack/react-query";
import { getDuplicateIdentifiers } from "../services/get-duplicate-identifiers";
import { ConsentFormStatus } from "@/pages/users/types/user";

export function useDuplicateIdentifiers({
  search,
  is_lead,
  product_id,
  hrc_status,
  mc_status,
  enabled,
}: {
  search?: string;
  is_lead?: boolean;
  product_id?: string;
  hrc_status?: ConsentFormStatus;
  mc_status?: ConsentFormStatus;
  enabled: boolean;
}) {
  return useQuery({
    queryKey: [
      "duplicate-identifiers",
      { search, is_lead, product_id, hrc_status, mc_status },
    ],
    queryFn: () =>
      getDuplicateIdentifiers({ search, is_lead, product_id, hrc_status, mc_status }),
    enabled: enabled && !!search,
    staleTime: 1000 * 60 * 5,
    refetchOnWindowFocus: false,
  });
}
